"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.freeRedeemAppendCodeApi = freeRedeemAppendCodeApi;
exports.freeRedeemCreateApi = freeRedeemCreateApi;
exports.freeRedeemDeleteApi = freeRedeemDeleteApi;
exports.freeRedeemDetailApi = freeRedeemDetailApi;
exports.freeRedeemExportCodeApi = freeRedeemExportCodeApi;
exports.freeRedeemListApi = freeRedeemListApi;
exports.freeRedeemRecordListApi = freeRedeemRecordListApi;
exports.freeRedeemUpdateApi = freeRedeemUpdateApi;
exports.freeRedeemUpdateStatusApi = freeRedeemUpdateStatusApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 批次列表
 * @param params
 */
function freeRedeemListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/exchange/batch/page',
    method: 'GET',
    params: params
  });
}

/**
 * 新增批次
 * @param data
 */
function freeRedeemCreateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/exchange/batch/save',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑批次
 * @param data
 */
function freeRedeemUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/exchange/batch/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除批次
 */
function freeRedeemDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/exchange/batch/delete/".concat(id),
    method: 'POST'
  });
}

/**
 * 批次详情
 * @param id
 */
function freeRedeemDetailApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/exchange/batch/detail/".concat(id),
    method: 'GET'
  });
}

/**
 * 设置批次状态
 * @param data
 */
function freeRedeemUpdateStatusApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/exchange/batch/updateStatus',
    method: 'POST',
    data: data
  });
}

/**
 * 设置批次状态
 * @param data
 */
function freeRedeemAppendCodeApi(data) {
  return (0, _request.default)({
    url: '/admin/platform/exchange/batch/appendCodes',
    method: 'POST',
    data: data
  });
}

/**
 * 导出批次兑换码
 * @param id
 */
function freeRedeemExportCodeApi(id) {
  return (0, _request.default)({
    url: "/admin/platform/exchange/batch/exportCodes/".concat(id),
    method: 'GET'
  });
}

/**
 * 兑换记录列表
 * @param params
 */
function freeRedeemRecordListApi(params) {
  return (0, _request.default)({
    url: '/admin/platform/exchange/detail/page',
    method: 'GET',
    params: params
  });
}